import React, { useEffect } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap-icons/font/bootstrap-icons.css";
import "../../../../styles/dashboardTheme.css";
import "../../../../styles/managementTheme.css";
import "../styles/promociones.css";
import { usePermissions } from "../../../../utils/permissions";
import CoordinacionTabs from "../../catalogo/components/CoordinacionTabs";
import PromocionesSumary from "../components/PromocionesSumary.jsx";
import PromocionFormModal from "../components/PromocionFormModal.jsx";
import PromocionesTableCard from "../components/PromocionesTableCard.jsx";
import PromocionesFilters from "../components/PromocionesFilters.jsx";
import ModalColaReservas from "../components/ModalColaReservas.jsx";


const estadoOptions = [
    { value: "programado", label: "Programado" },
    { value: "en_curso", label: "En curso" },
    { value: "finalizado", label: "Finalizado" },
    { value: "cancelado", label: "Cancelado" },
];

const formatDate = (value) => {
    if (!value) return "-";
    const raw =
        typeof value === "string"
            ? value.split("T")[0]
            : new Date(value).toISOString().split("T")[0];
    const parts = raw.split("-");
    if (parts.length !== 3) return raw || value;
    const [year, month, day] = parts;
    return `${day}/${month}/${year}`;
};

const estadoBadgeClass = (estado = "") => {
    const normalized = estado.toLowerCase();
    if (normalized === "finalizado") return "bg-secondary text-white";
    if (normalized === "en_curso") return "bg-primary text-white";
    if (normalized === "cancelado") return "bg-danger text-white";
    return "bg-info text-dark";
};

const activoBadgeClass = (activo) =>
    activo ? "bg-success-subtle text-success" : "bg-secondary-subtle text-muted";

const formatPercent = (value) => {
    const num = Number(value);
    if (Number.isNaN(num)) return "-";
    return `${num.toFixed(2)}%`;
};

export default function PromocionesView({
    promociones,
    promocionesPaginadas,
    cursos,
    cursosDisponiblesNuevo,
    cursosDisponiblesEditar,
    cursosLoadingNuevo,
    cursosLoadingEditar,
    horariosNuevo,
    horariosEditar,
    horariosLoadingNuevo,
    horariosLoadingEditar,
    horariosErrorNuevo,
    horariosErrorEditar,
    previewNuevo,
    previewEditar,
    previewLoadingNuevo,
    previewLoadingEditar,
    previewErrorNuevo,
    previewErrorEditar,
    ciclos,
    ciclosLoading,
    ciclosError,
    numeroPromocionLoading,
    numeroPromocionError,
    loading,
    listError,
    cursosLoading,
    cursosError,
    filtros,
    setFiltros,
    limpiarFiltros,
    lastUpdated,
    page,
    pageSize,
    totalPages,
    total,
    goToPage,
    modal,
    filtro,
    promocionSeleccionada,
    formNuevo,
    setFormNuevo,
    formEditar,
    setFormEditar,
    savingNuevo,
    savingEditar,
    deleting,
    detalleLoading,
    abrirModalNuevo,
    abrirModalEditar,
    abrirModalEliminar,
    cerrarModal,
    reload,
    reloadCursos,
    reloadCiclos,
    reloadNumeroPromocion,
    aplicarFiltro,
    stats,
    handleCrearPromocion,
    handleActualizarPromocion,
    handleEliminarPromocion,
    handleToggleCancelPromocion,
    colaFifoPromocion,
    colaFifoReservas,
    colaFifoAsignando,
    cerrarColaFifo,
    handleAsignarReservas,
}) {
    const { hasPermission } = usePermissions();
    const canCreatePromocion = hasPermission("promociones.crear");
    const canUpdatePromocion = hasPermission("promociones.actualizar");
    const canDeletePromocion = hasPermission("promociones.eliminar");
    const canManagePromociones = canUpdatePromocion || canDeletePromocion;
    const canViewDetallePromocion =
        hasPermission("promociones.inscritos.listar") ||
        hasPermission("promociones.notas.listar") ||
        hasPermission("promociones.diplomas.listar");

    useEffect(() => {
        if (typeof document === "undefined") return undefined;
        if (modal) {
            document.body.classList.add("modal-open");
        } else {
            document.body.classList.remove("modal-open");
        }
        return () => document.body.classList.remove("modal-open");
    }, [modal]);

    const lastSync = lastUpdated ? lastUpdated.toLocaleString() : "Sincronizacion inicial";

    return (
        <section className="management-page management-theme-violet promociones-wrapper">
            {colaFifoPromocion && (
                <ModalColaReservas
                    promocion={colaFifoPromocion}
                    reservas={colaFifoReservas}
                    asignando={colaFifoAsignando}
                    onAsignar={handleAsignarReservas}
                    onCerrar={cerrarColaFifo}
                />
            )}
            <CoordinacionTabs />
            <div className="management-card management-header mb-4">
                <div>
                    <p className="management-eyebrow mb-1">Formacion academica</p>
                    <h4 className="management-title mb-1">Gestion de promociones</h4>
                    <p className="text-muted mb-0">Administra los grupos de estudiantes asignados a cada curso.</p>
                </div>
                <div className="d-flex flex-column align-items-end gap-2">
                    {canCreatePromocion && (
                        <button type="button" className="btn management-btn-primary" onClick={abrirModalNuevo}>
                            <i className="bi bi-plus-circle me-2" />
                            Nueva promocion
                        </button>
                    )}
                    <small className="text-muted">Actualizado: {lastSync}</small>
                </div>
            </div>

            <PromocionesSumary stats={stats} filtro={filtro} aplicarFiltro={aplicarFiltro} />

            <PromocionesFilters
                filtros={filtros}
                setFiltros={setFiltros}
                limpiarFiltros={limpiarFiltros}
                estadoOptions={estadoOptions}
                cursos={cursos}
                cursosLoading={cursosLoading}
            />

            {(listError || cursosError) && (
                <div className="alert alert-warning d-flex align-items-center justify-content-between management-alert mb-4">
                    <div className="me-3">
                        {listError && <p className="mb-1">Promociones: {listError}</p>}
                        {cursosError && <p className="mb-0">Cursos: {cursosError}</p>}
                    </div>
                    <div className="d-flex gap-2 flex-wrap">
                        {listError && (
                            <button type="button" className="btn btn-sm btn-outline-secondary" onClick={reload}>
                                Reintentar promociones
                            </button>
                        )}
                        {cursosError && (
                            <button
                                type="button"
                                className="btn btn-sm btn-outline-secondary"
                                onClick={reloadCursos}
                            >
                                Reintentar cursos
                            </button>
                        )}
                    </div>
                </div>
            )}

            <PromocionesTableCard
                promociones={promocionesPaginadas ?? promociones}
                loading={loading}
                listError={listError}
                reload={reload}
                estadoOptions={estadoOptions}
                formatDate={formatDate}
                formatPercent={formatPercent}
                estadoBadgeClass={estadoBadgeClass}
                activoBadgeClass={activoBadgeClass}
                canManagePromociones={canManagePromociones}
                canViewDetallePromocion={canViewDetallePromocion}
                canUpdatePromocion={canUpdatePromocion}
                canDeletePromocion={canDeletePromocion}
                abrirModalEditar={abrirModalEditar}
                abrirModalEliminar={abrirModalEliminar}
            />

            <div className="management-card d-flex justify-content-between align-items-center flex-wrap gap-3">
                <div className="text-muted small">
                    Mostrando {total === 0 ? 0 : (page - 1) * pageSize + 1}-{Math.min(total, page * pageSize)} de {total}
                </div>
                <div className="d-flex align-items-center gap-2 flex-wrap">
                    <div className="btn-group">
                        <button className="btn btn-outline-secondary btn-sm" onClick={() => goToPage(page - 1)} disabled={page <= 1}>
                            <i className="bi bi-chevron-left" />
                        </button>
                        <button className="btn btn-outline-secondary btn-sm" disabled>
                            Pagina {page} / {totalPages}
                        </button>
                        <button
                            className="btn btn-outline-secondary btn-sm"
                            onClick={() => goToPage(page + 1)}
                            disabled={page >= totalPages}
                        >
                            <i className="bi bi-chevron-right" />
                        </button>
                    </div>
                </div>
            </div>

            <PromocionFormModal
                modal={modal}
                cerrarModal={cerrarModal}
                formNuevo={formNuevo}
                setFormNuevo={setFormNuevo}
                formEditar={formEditar}
                setFormEditar={setFormEditar}
                cursosNuevo={cursosDisponiblesNuevo}
                cursosEditar={cursosDisponiblesEditar}
                cursosLoadingNuevo={cursosLoadingNuevo}
                cursosLoadingEditar={cursosLoadingEditar}
                cursosError={cursosError}
                reloadCursos={reloadCursos}
                horariosNuevo={horariosNuevo}
                horariosEditar={horariosEditar}
                horariosLoadingNuevo={horariosLoadingNuevo}
                horariosLoadingEditar={horariosLoadingEditar}
                horariosErrorNuevo={horariosErrorNuevo}
                horariosErrorEditar={horariosErrorEditar}
                previewNuevo={previewNuevo}
                previewEditar={previewEditar}
                previewLoadingNuevo={previewLoadingNuevo}
                previewLoadingEditar={previewLoadingEditar}
                previewErrorNuevo={previewErrorNuevo}
                previewErrorEditar={previewErrorEditar}
                ciclos={ciclos}
                ciclosLoading={ciclosLoading}
                ciclosError={ciclosError}
                reloadCiclos={reloadCiclos}
                numeroPromocionLoading={numeroPromocionLoading}
                numeroPromocionError={numeroPromocionError}
                reloadNumeroPromocion={reloadNumeroPromocion}
                estadoOptions={estadoOptions}
                savingNuevo={savingNuevo}
                savingEditar={savingEditar}
                deleting={deleting}
                detalleLoading={detalleLoading}
                canCreatePromocion={canCreatePromocion}
                canUpdatePromocion={canUpdatePromocion}
                canDeletePromocion={canDeletePromocion}
                promocionSeleccionada={promocionSeleccionada}
                handleCrearPromocion={handleCrearPromocion}
                handleActualizarPromocion={handleActualizarPromocion}
                handleEliminarPromocion={handleEliminarPromocion}
                onToggleCancel={handleToggleCancelPromocion}
            />
        </section>
    );
}





